import * as React from 'react';
import { createRoot } from 'react-dom/client';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/joy/CssBaseline';
import { CssVarsProvider } from '@mui/joy/styles';
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://3b417cae41492cb5cd528fbe1d2ed54f@o1155528.ingest.us.sentry.io/4510873248530432",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost"],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

import reportWebVitals from './reportWebVitals';
import {initialize} from 'utils/ParseUtils';
import createAppStore from './store';
import theme from './theme';

import Layout from "./components/ui/Layout";
import ForgotPassword from "./views/ForgotPassword";
import Authorize from "./components/ui/Authorize";
import Dashboard from "./views/Dashboard";
import TaxonomyView from "./views/TaxonomyView";
import TaxonomyEdit from "./views/TaxonomyEdit";
import ObservationAdd from "./views/ObservationAdd";
import ObservationEdit from "./views/ObservationEdit";
import TaxonomyAdd from "./views/TaxonomyAdd";
import ObservationView from "./views/ObservationView";
import ObservationImport from "./views/ObservationImport";
import SystemAdmin from "./views/SystemAdmin";
import ObservationQuery from "./views/ObservationQuery";
import EvidenceView from "./views/EvidenceView";
import EvidenceAdd from "./views/EvidenceAdd";
import EvidenceEdit from "./views/EvidenceEdit";
import EventView from "./views/EventView";
import LocationView from "./views/LocationView";
import NotFound from "./views/NotFound";

initialize();
const store = createAppStore();
const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <CssVarsProvider theme={theme} defaultMode="light">
            <CssBaseline />
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route exact path="/forgot-password" element={<ForgotPassword />} />
                        <Route element={<Authorize />}>
                            <Route exact path="/" element={<Dashboard />} />
                            <Route exact path="/taxonomy/search" element={<Dashboard />} />
                            <Route path="/taxonomy/:taxonomyNameId" element={<TaxonomyView />} />
                            <Route path="/taxonomy/:taxonomyNameId/add-observation" element={<ObservationAdd />} />
                            <Route path="/taxonomy/:taxonomyId/edit" element={<TaxonomyEdit />} />
                            <Route path="/taxonomy/add" element={<TaxonomyAdd />} />
                            <Route path="/observation/:observationId" element={<ObservationView />} />
                            <Route path="/observation/:observationId/edit" element={<ObservationEdit />} />
                            <Route path="/observation/add" element={<ObservationAdd />} />
                            <Route path="/observation/import" element={<ObservationImport />} />
                            <Route path='system-admin' element={<SystemAdmin />} />
                            <Route path='system-admin/:tableName' element={<SystemAdmin />} />
                            <Route path='observation-query' element={<ObservationQuery />} />
                            <Route path="/evidence/:evidenceId" element={<EvidenceView />} />
                            <Route path="/evidence/:evidenceId/edit" element={<EvidenceEdit />} />
                            <Route path="/evidence/add" element={<EvidenceAdd />} />
                            <Route path="/event/:eventId" element={<EventView />} />
                            <Route path="/location/:locationId" element={<LocationView />} />
                        </Route>
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </CssVarsProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// eslint-disable-next-line no-console
reportWebVitals(console.info);
